/**
 * Texto de exibição para os marcadores internos que o backend grava quando a
 * mensagem não é texto puro: "[unsupported]", "[system]", "[imagem]",
 * "[localizacao]", "[Interativo: nfm_reply]"...
 *
 * Caso Gelo Americano (2026-10-02): o inbox mostrava esses marcadores crus,
 * em inglês e entre colchetes, e no Instagram/Messenger repetia "[imagem]"
 * embaixo da própria imagem. O backend novo já grava texto legível
 * (services/wa_business/message_text.py); este mapa cobre as mensagens
 * ANTIGAS, que continuam com o marcador no banco.
 *
 * COMPARTILHADO pelos inboxes (core). Texto que não é marcador passa intacto.
 */

const UNSUPPORTED =
  'Mensagem que o canal não entrega para a plataforma (por exemplo enquete, visualização única ou evento). Veja no aplicativo.';

// Marcador que só repete a mídia que já aparece na bolha.
const MEDIA_KEYS = new Set([
  'imagem', 'image', 'video', 'vídeo', 'audio', 'áudio', 'arquivo', 'file',
  'document', 'documento', 'sticker', 'figurinha', 'anexo',
]);

const LABELS = {
  unsupported: UNSUPPORTED,
  unknown: UNSUPPORTED,
  'mensagem nao suportada': UNSUPPORTED,
  'mensagem não suportada': UNSUPPORTED,
  system: 'Aviso do WhatsApp',
  request_welcome: 'O cliente abriu a conversa pelo WhatsApp',
  localizacao: 'Localização',
  location: 'Localização',
  contacts: 'Contato compartilhado',
  'link compartilhado': 'Link compartilhado',
  'mensagem estruturada': 'Mensagem estruturada',
  'publicacao compartilhada': 'Publicação compartilhada',
  sticker: 'Figurinha',
  imagem: 'Imagem',
  image: 'Imagem',
  video: 'Vídeo',
  audio: 'Áudio',
  arquivo: 'Arquivo',
  document: 'Documento',
  anexo: 'Anexo',
  button: 'Resposta de botão',
  interactive: 'Mensagem interativa',
};

/**
 * @param {string|null|undefined} text texto gravado
 * @param {{hasMedia?: boolean}} opts a bolha já desenha uma mídia?
 * @returns {string|null} texto a exibir, ou null para não exibir nada
 */
export function displayText(text, { hasMedia = false } = {}) {
  if (typeof text !== 'string') return text ?? null;
  const m = /^\[([^\]\n]{1,60})\]$/.exec(text.trim());
  if (!m) return text;
  const key = m[1].trim().toLowerCase();
  if (hasMedia && MEDIA_KEYS.has(key)) return null;
  if (key.startsWith('interativo')) return 'Mensagem interativa';
  return LABELS[key] || text;
}

/**
 * Prévia da lista de conversas. Além dos marcadores entre colchetes, cobre o
 * nome cru do tipo ("unsupported", "location", "sticker"), que o backend usa
 * como prévia quando a mensagem não tem texto.
 */
export function previewText(text) {
  if (typeof text !== 'string') return text ?? '';
  const t = text.trim();
  if (/^[a-z_]{3,30}$/.test(t) && LABELS[t]) {
    return t === 'unsupported' || t === 'unknown' ? 'Mensagem não suportada' : LABELS[t];
  }
  const shown = displayText(t);
  return shown === UNSUPPORTED ? 'Mensagem não suportada' : (shown ?? '');
}

export default displayText;
